module.exports = __webpack_public_path__ + "static/media/th-list.07582a5b.svg";